export default "__VITE_ASSET__cbe9b276__"